import React from 'react';

const Georgia = () => {
  return (
    <div>
      
    </div>
  );
}

export default Georgia;
